import React, { memo } from "react";
import { PageContainer, Button, Box, Header, useMatchMedia } from "@pochta/ui";
import ErrorPageLogo from "./components/ErrorPageLogo";
import { ErrorPageMain, ErrorPageWrapper } from "./ErrorPage.styles";

var NoCookiesPage = function NoCookiesPage(_ref) {
  var _ref$cookiesLink = _ref.cookiesLink,
      cookiesLink = _ref$cookiesLink === void 0 ? null : _ref$cookiesLink;
  var mobile = useMatchMedia("mobile");
  return /*#__PURE__*/React.createElement(ErrorPageMain, null, /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(ErrorPageWrapper, null, /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ErrorPageLogo, {
    isMobile: mobile
  }), /*#__PURE__*/React.createElement(Header, {
    variant: "h1",
    withPaddingTop: true
  }, "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442\u0441\u044F \u0432\u043E\u0439\u0442\u0438"), /*#__PURE__*/React.createElement(Box, null, "\u0414\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435 cookies."), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    mt: "35px",
    as: "a",
    href: cookiesLink
  }, "\u0412\u043E\u0439\u0442\u0438 \u0437\u0430\u043D\u043E\u0432\u043E")))));
};

export default /*#__PURE__*/memo(NoCookiesPage);